import {CompositeDecorator, ContentBlock, ContentState} from "draft-js";
// eslint-disable-next-line import/no-unresolved
import {MentionProps} from "@draft-js-plugins/mention/lib/Mention";
import React from "react";
import {useTheme} from "@material-ui/core";

const mentionStrategy = (
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void,
  contentState: ContentState
) => {
  contentBlock.findEntityRanges((character) => {
    const key = character.getEntity();
    return key !== null && contentState.getEntity(key).getType() === "mention";
  }, callback);
};
const MentionComponent = (props: MentionProps) => {
  const theme = useTheme();
  const {mention} = props.contentState.getEntity(props.entityKey).getData();
  return (
    <span style={{color: theme.palette.primary.main}}>@{mention.name}</span>
  );
};
export const mentionDecorator = new CompositeDecorator([
  {
    strategy: mentionStrategy,
    component: MentionComponent,
  },
]);
